var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal__offer" }, [
    _c("img", {
      attrs: { src: _vm.mediaBaseUrl + "after-quiz/timeout2.png", alt: "" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "bg" }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-offer__content" }, [
      _c("h2", [
        _vm._v("Are you sure you want to lose your personalized plan?")
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("We have prepared for you:")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "benefits" },
        _vm._l(_vm.benefits, function(benefit) {
          return _c("div", { key: benefit, staticClass: "benefit" }, [
            _c("img", {
              attrs: {
                src: _vm.mediaBaseUrl + "after-quiz/benefit-marker.svg",
                alt: "marker"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(benefit))])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "offer__actions" },
        [
          _c("custom-button", { on: { click: _vm.handleReject } }, [
            _vm._v("\n        Lose all the benefits\n      ")
          ]),
          _vm._v(" "),
          _c(
            "custom-button",
            {
              attrs: { secondary: true },
              on: {
                click: function($event) {
                  return _vm.$emit("changeModal", "payment")
                }
              }
            },
            [_vm._v("\n        Start Free Trial\n      ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }